import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from "@angular/router";
import { LanguageFacade } from "@redux/facades/language.facade";

@Component({
  standalone: false,
  selector: 'app-landing-layout',
  templateUrl: './landing-layout.component.html',
  styleUrls: ['./landing-layout.component.scss']
})
export class LandingLayoutComponent implements OnInit {
  public lang: string | null = null;

  constructor(
    public location: Location,
    public languageFacade: LanguageFacade,
    private _Activatedroute: ActivatedRoute
  ) {
    const self = this;
    const _lang = self._Activatedroute.snapshot.paramMap.get('lang');
    self.lang = _lang !== null ? _lang : 'en';
    self.languageFacade.setLanguage(self.lang);
  }

  ngOnInit() {
  }
}
